import React, { useState, useEffect } from "react";
import { TextField, Card, CardContent, Typography } from "@mui/material";
//import '../../css/SignUpForm.css'; // Optionally import a specific CSS file for the form
import SriyanshCardHeader from "../../components/CardHeader";
import DropdownfromDatabaseList from "../../CustomComponant/DropdownfromDatabaseList";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";
import EncryptService from "../../service/EncryptionService";
import { useNavigate } from "react-router-dom";

import { List, ListItem, ListItemText, Box } from "@mui/material"; // add for List Box
const SignUpForm = () => {
  const [role, setRole] = useState("");
  const [roles, setRoles] = useState([]);

  // add for List Box START/////////////
  const [list1, setList1] = useState([]);
  const [list2, setList2] = useState([]);

  const sortItems = (items) => {
    return [...items].sort((a, b) => a.Shop.localeCompare(b.Shop));
  };

  const handleTransferToSelected = (item) => {
    const updatedList1 = list1.filter(
      (i) => i.ConsigneeCode !== item.ConsigneeCode
    );
    const updatedList2 = [...list2, item];
    setList1(sortItems(updatedList1));
    setList2(sortItems(updatedList2));
  };

  const handleTransferToAvailable = (item) => {
    const updatedList2 = list2.filter(
      (i) => i.ConsigneeCode !== item.ConsigneeCode
    );
    const updatedList1 = [...list1, item];
    setList1(sortItems(updatedList1));
    setList2(sortItems(updatedList2));
  };

  // Fetch initial data from the database
  useEffect(() => {
    apiClient
      .post("/ConsigneeList")
      .then((response) => setList1(response.data), setList2([]))
      .catch((error) => console.error("Error fetching data:", error));
  }, [role]);

  // ///////////////////add for List Box END///////////////////

  // Function to fetch roles from the API


  const toProperCase = (str) =>
    str
      .replace(/^\s+/, "") // Remove leading spaces
      .replace(/\s+/g, " ")
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ")
      ;




  const fetchRoles = async () => {
    try {
      const response = await apiClient.post("/roleList", {
        /* request payload if needed */
      });
      setRoles(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const [fname, setfName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  //const [role, setRole] = useState("user"); // Default role is 'user'
  const [errors, setErrors] = useState({});
  const [consignee, setconsignee] = useState("");
  const [consignees, setconsignees] = useState([]);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleClose = () => {
    navigate("../polist", { replace: true });
  };

  const fetchConsignees = async () => {
    try {
      const response = await apiClient.post("/ConsigneeList", {
        /* request payload if needed */
      });
      setconsignees(response.data);
      //setList1(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(() => {
    fetchConsignees();
    fetchRoles();
  }, []);

  useEffect(() => {
    if (consignees.length > 0) {
      setconsignee(consignees[0].ConsigneeCode);
    }

    if (roles.length > 0) {
      setRole(roles[2].id);
    }
  }, [consignees, roles, username]);

  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      // Allow only numeric values
      setMobileNumber(value);
    }
  };

  const tokenServiceDetails = TokenService.getUserDetails();
  const logineuname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const InsertNewLogin = async (e) => {
    e.preventDefault();

    // uname,passwrd,rights,fname,email,mobile,cretedby,vip,

    let formErrors = {};
    if (!fname) formErrors.name = "Name is required";
    if (!email) formErrors.email = "Email is required";
    if (!password) formErrors.password = "Password is required";
    if (!username) formErrors.username = "Username is required";
    if (!mobileNumber) formErrors.mobileNumber = "Mobile number is required";
    if (mobileNumber && mobileNumber.length !== 10)
      formErrors.mobileNumber = "Mobile number must be 10 digits";
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailPattern.test(email)) {
      formErrors.email = "Email is invalid";
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      //vconsignee: role === 4 ? consignee : itemCodes,

      const itemCodes = list2.map((item) => item.ConsigneeCode).join(",");
      const vconsignee1 = (role === 3 || role === 4 || role === 6 ) ? itemCodes : consignee;
     // console.log(consignee);
     // console.log(role);
    //  console.log(itemCodes);
     // console.log(vconsignee1);

      apiClient
        .post("/newlogin", {
          uname: username,
          passwrd: password,
          rights: role,
          fname: fname,
          email: email,
          mobile: mobileNumber,
          cretedby: logineuname,
          vip: ip,
          vconsignee: vconsignee1.toString(),
        })
        .then(function (response) {
          setErrors(response.data);

          setfName("");
          setEmail("");
          setPassword("");
          setUsername("");
          setMobileNumber("");
          if (roles.length > 0) {
            setRole(roles[2].role);
          }
        })
        .catch(function (error) {
          if (
            error.response.data &&
            error.response.data.code === "ER_DUP_ENTRY"
          ) {
            alert("Duplicate User Not Allowed");
          }
        });
    }
  };

  return (
  <Box
    className="signup-page"
    sx={{
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      boxSizing: "border-box",
      px: { xs: 0.75, sm: 1.25, md: 2 },
      py: { xs: 0.75, sm: 1, md: 1.5 },
      overflowX: "hidden",
    }}
  >
    <Card
      className="signup-card"
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        overflow: "hidden",
        borderRadius: { xs: 2, md: 3 },
        border: "1px solid #dbe5f1",
        background: "#fff",
        boxShadow: "0 8px 28px rgba(13, 71, 161, 0.10)",
      }}
    >
      {/* ================= HEADER ================= */}
      <Box
        sx={{
          background:
            "linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%)",
          color: "#fff",
          px: { xs: 1.5, sm: 2, md: 2.5 },
          py: { xs: 1.3, sm: 1.5, md: 1.7 },
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "1rem",
              sm: "1.1rem",
              md: "1.25rem",
            },
            fontWeight: 700,
            lineHeight: 1.3,
          }}
        >
          Create New User
        </Typography>
      </Box>

      <CardContent
        sx={{
          p: { xs: 1, sm: 1.5, md: 2 },
          "&:last-child": {
            pb: { xs: 1.5, sm: 2, md: 2.5 },
          },
        }}
      >
        {/* ================= USER INFORMATION ================= */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            border: "1px solid #dbe5f1",
            borderRadius: 2,
            background: "#fff",
            p: { xs: 1.25, sm: 1.5, md: 2 },
            mb: { xs: 1.5, md: 2 },
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: "0.9rem",
                sm: "0.95rem",
                md: "1rem",
              },
              fontWeight: 700,
              color: "#0D47A1",
              mb: { xs: 1.25, sm: 1.5 },
              pl: 1,
              borderLeft: "4px solid #1976D2",
              lineHeight: 1.4,
            }}
          >
            User Information
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "1fr 1fr",
              },
              gap: { xs: 1.5, sm: 2, md: 2.5 },
              width: "100%",
              minWidth: 0,
            }}
          >
            {/* FULL NAME */}
            <Box sx={{ width: "100%", minWidth: 0 }}>
              <TextField
                label="Full Name"
                variant="outlined"
                value={fname}
                size="small"
                onChange={(e) =>
                  setfName(toProperCase(e.target.value))
                }
                fullWidth
                error={!!errors.fname}
                helperText={errors.fname}
                inputProps={{ maxLength: 30 }}
              />
            </Box>

            {/* EMAIL */}
            <Box sx={{ width: "100%", minWidth: 0 }}>
              <TextField
                label="Email"
                variant="outlined"
                type="email"
                size="small"
                value={email}
                onChange={(e) =>
                  setEmail(e.target.value.toLowerCase())
                }
                fullWidth
                error={!!errors.email}
                helperText={errors.email}
                inputProps={{ maxLength: 50 }}
              />
            </Box>

            {/* USER ID */}
            <Box sx={{ width: "100%", minWidth: 0 }}>
              <TextField
                label="User ID"
                variant="outlined"
                size="small"
                value={username}
                onChange={(e) =>
                  setUsername(e.target.value.toLowerCase())
                }
                fullWidth
                error={!!errors.username}
                helperText={errors.username}
                inputProps={{ maxLength: 10 }}
              />
            </Box>

            {/* PASSWORD */}
            <Box sx={{ width: "100%", minWidth: 0 }}>
              <TextField
                label="Password"
                variant="outlined"
                size="small"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) =>
                  setPassword(e.target.value)
                }
                fullWidth
                error={!!errors.password}
                helperText={errors.password}
                inputProps={{ maxLength: 15 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        edge="end"
                        aria-label="toggle password visibility"
                      >
                        {showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            {/* MOBILE */}
            <Box sx={{ width: "100%", minWidth: 0 }}>
              <TextField
                label="Mobile Number"
                size="small"
                variant="outlined"
                type="tel"
                value={mobileNumber}
                onChange={handleMobileNumberChange}
                fullWidth
                error={!!errors.mobileNumber}
                helperText={errors.mobileNumber}
                inputProps={{
                  maxLength: 10,
                  pattern: "[0-9]*",
                }}
              />
            </Box>

            {/* ROLE */}
            <Box sx={{ width: "100%", minWidth: 0 }}>
              <DropdownfromDatabaseList
                size="small"
                Options={roles}
                option={role}
                setOptionValue={setRole}
                DisplayItem1="role"
                DisplayItem2="id"
              />
            </Box>
          </Box>
        </Box>

        {/* =====================================================
            CONSIGNEE SELECTION FOR ROLES 3, 4, 6
            ===================================================== */}
        {(role === 3 || role === 4 || role === 6) && (
          <Box
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              border: "1px solid #dbe5f1",
              borderRadius: 2,
              background: "#fff",
              p: { xs: 1.25, sm: 1.5, md: 2 },
              mb: { xs: 1.5, md: 2 },
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "0.9rem",
                  sm: "0.95rem",
                  md: "1rem",
                },
                fontWeight: 700,
                color: "#0D47A1",
                mb: { xs: 1.25, sm: 1.5 },
                pl: 1,
                borderLeft: "4px solid #1976D2",
              }}
            >
              Consignee Selection
            </Typography>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  md: "1fr 1fr",
                },
                gap: { xs: 1.5, md: 2 },
                width: "100%",
                minWidth: 0,
              }}
            >
              {/* AVAILABLE */}
              <Box
                sx={{
                  width: "100%",
                  minWidth: 0,
                  border: "1px solid #c9d8eb",
                  borderRadius: 2,
                  overflow: "hidden",
                  background: "#f8fbff",
                }}
              >
                <Box
                  sx={{
                    background:
                      "linear-gradient(135deg, #1565C0, #1976D2)",
                    color: "#fff",
                    px: 1.5,
                    py: 1,
                    textAlign: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "0.85rem",
                        sm: "0.95rem",
                      },
                      fontWeight: 700,
                    }}
                  >
                    Available Consignees
                  </Typography>
                </Box>

                <Box
                  sx={{
                    maxHeight: 300,
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  <List disablePadding>
                    {list1.map((item) => (
                      <ListItem
                        key={item.ConsigneeCode}
                        button
                        onClick={() =>
                          handleTransferToSelected(item)
                        }
                        sx={{
                          borderBottom:
                            "1px solid #e5edf7",
                          px: { xs: 1, sm: 1.5 },
                          py: 0.8,
                          cursor: "pointer",

                          "&:hover": {
                            background: "#e3f2fd",
                          },
                        }}
                      >
                        <ListItemText
                          primary={item.Shop}
                          secondary={item.ConsigneeCode}
                          primaryTypographyProps={{
                            fontSize: {
                              xs: "0.82rem",
                              sm: "0.9rem",
                            },
                            fontWeight: 600,
                            sx: {
                              overflowWrap: "anywhere",
                              wordBreak: "break-word",
                            },
                          }}
                          secondaryTypographyProps={{
                            fontSize: {
                              xs: "0.72rem",
                              sm: "0.78rem",
                            },
                            sx: {
                              overflowWrap: "anywhere",
                              wordBreak: "break-word",
                            },
                          }}
                        />
                      </ListItem>
                    ))}

                    {list1.length === 0 && (
                      <Box
                        sx={{
                          py: 3,
                          textAlign: "center",
                          color: "#78909c",
                        }}
                      >
                        <Typography variant="body2">
                          No available consignee
                        </Typography>
                      </Box>
                    )}
                  </List>
                </Box>
              </Box>

              {/* SELECTED */}
              <Box
                sx={{
                  width: "100%",
                  minWidth: 0,
                  border: "1px solid #c9d8eb",
                  borderRadius: 2,
                  overflow: "hidden",
                  background: "#f8fbff",
                }}
              >
                <Box
                  sx={{
                    background:
                      "linear-gradient(135deg, #0D47A1, #1565C0)",
                    color: "#fff",
                    px: 1.5,
                    py: 1,
                    textAlign: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "0.85rem",
                        sm: "0.95rem",
                      },
                      fontWeight: 700,
                    }}
                  >
                    Selected Consignees
                  </Typography>
                </Box>

                <Box
                  sx={{
                    maxHeight: 300,
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  <List disablePadding>
                    {list2.map((item) => (
                      <ListItem
                        key={item.ConsigneeCode}
                        button
                        onClick={() =>
                          handleTransferToAvailable(item)
                        }
                        sx={{
                          borderBottom:
                            "1px solid #e5edf7",
                          px: { xs: 1, sm: 1.5 },
                          py: 0.8,
                          cursor: "pointer",

                          "&:hover": {
                            background: "#e3f2fd",
                          },
                        }}
                      >
                        <ListItemText
                          primary={item.Shop}
                          secondary={item.ConsigneeCode}
                          primaryTypographyProps={{
                            fontSize: {
                              xs: "0.82rem",
                              sm: "0.9rem",
                            },
                            fontWeight: 600,
                            sx: {
                              overflowWrap: "anywhere",
                              wordBreak: "break-word",
                            },
                          }}
                          secondaryTypographyProps={{
                            fontSize: {
                              xs: "0.72rem",
                              sm: "0.78rem",
                            },
                            sx: {
                              overflowWrap: "anywhere",
                              wordBreak: "break-word",
                            },
                          }}
                        />
                      </ListItem>
                    ))}

                    {list2.length === 0 && (
                      <Box
                        sx={{
                          py: 3,
                          textAlign: "center",
                          color: "#78909c",
                        }}
                      >
                        <Typography variant="body2">
                          No selected consignee
                        </Typography>
                      </Box>
                    )}
                  </List>
                </Box>
              </Box>
            </Box>
          </Box>
        )}

        {/* =====================================================
            SINGLE CONSIGNEE ROLE
            ===================================================== */}
        {role === 2 && (
          <Box
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              border: "1px solid #dbe5f1",
              borderRadius: 2,
              background: "#fff",
              p: { xs: 1.25, sm: 1.5, md: 2 },
              mb: { xs: 1.5, md: 2 },
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "0.9rem",
                  sm: "0.95rem",
                  md: "1rem",
                },
                fontWeight: 700,
                color: "#0D47A1",
                mb: 1.5,
                pl: 1,
                borderLeft: "4px solid #1976D2",
              }}
            >
              Consignee
            </Typography>

            <Box
              sx={{
                width: "100%",
                minWidth: 0,
              }}
            >
              <DropdownfromDatabaseList
                Options={consignees}
                option={consignee}
                setOptionValue={setconsignee}
                DisplayItem1="Shop"
                DisplayItem2="ConsigneeCode"
                showKeyInLabel={true}
                multiselect={true}
              />
            </Box>
          </Box>
        )}

        {/* ================= ACTION BUTTONS ================= */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
            },
            gap: { xs: 1, sm: 1.5, md: 2 },
            mt: { xs: 1, md: 1.5 },
          }}
        >
          <button
            type="button"
            onClick={InsertNewLogin}
            title="Click for Data Entry"
            className="signup-action-btn signup-create-btn"
          >
            Create Login
          </button>

          <button
            type="button"
            onClick={handleClose}
            title="Close"
            className="signup-action-btn signup-close-btn"
          >
            Close
          </button>
        </Box>
      </CardContent>
    </Card>

    {/* ================= RESPONSIVE CSS ================= */}
    <style>{`
      .signup-page,
      .signup-page * {
        box-sizing: border-box;
      }

      .signup-page {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        overflow-x: hidden;
      }

      .signup-card {
        width: 100%;
        max-width: 100%;
        min-width: 0;
      }

      /* ================= FORM FIELDS ================= */

      .signup-card .MuiFormControl-root,
      .signup-card .MuiTextField-root {
        width: 100%;
        max-width: 100%;
        min-width: 0;
      }

      /* ================= LIST ================= */

      .signup-card .MuiListItemText-root {
        min-width: 0;
      }

      .signup-card .MuiListItemText-primary,
      .signup-card .MuiListItemText-secondary {
        overflow-wrap: anywhere !important;
        word-break: break-word !important;
        white-space: normal !important;
      }

      /* ================= BUTTONS ================= */

      .signup-action-btn {
        width: 100%;
        min-height: 44px;
        border: none;
        border-radius: 8px;
        padding: 10px 16px;
        color: #fff;
        font-size: 0.9rem;
        font-weight: 700;
        cursor: pointer;
        transition:
          transform 0.18s ease,
          box-shadow 0.18s ease;
      }

      .signup-create-btn {
        background:
          linear-gradient(
            135deg,
            #1565C0 0%,
            #1976D2 100%
          );

        box-shadow:
          0 4px 12px rgba(21, 101, 192, 0.25);
      }

      .signup-close-btn {
        background:
          linear-gradient(
            135deg,
            #c62828 0%,
            #e53935 100%
          );

        box-shadow:
          0 4px 12px rgba(198, 40, 40, 0.20);
      }

      .signup-action-btn:hover {
        transform: translateY(-1px);
      }

      .signup-action-btn:active {
        transform: translateY(0);
      }

      /* ================= TABLET ================= */

      @media (max-width: 900px) {
        .signup-card {
          border-radius: 12px;
        }
      }

      /* ================= MOBILE ================= */

      @media (max-width: 600px) {
        .signup-page {
          padding-left: 4px !important;
          padding-right: 4px !important;
        }

        .signup-card {
          border-radius: 10px !important;
        }

        .signup-action-btn {
          min-height: 42px;
          font-size: 0.85rem;
        }
      }

      /* ================= SMALL MOBILE ================= */

      @media (max-width: 400px) {
        .signup-action-btn {
          min-height: 40px;
          font-size: 0.82rem;
        }
      }
    `}</style>
  </Box>
);
};

export default SignUpForm;
